import React from 'react';
import { connect } from 'react-redux';
import style from './DistanceText.css';
function computeMaxDistance(course, activities, tracks) {
    const hasSegmentCourse = course && course.type === 'SegmentCourse';
    const seekId = hasSegmentCourse ? '__courseActivity' : tracks.activeTrack;
    const profileId = course ? '__courseActivity' : seekId;
    const profileAct = activities[profileId];
    const profileTrack = tracks.tracks[profileId];
    const maxDistance = profileAct && profileAct.cumulativeDistance ? profileAct.cumulativeDistance : profileTrack.cumulative.last;
    return maxDistance;
}
function mapStateToProps(state) {
    if (state.tracks.activeTrack) {
        const hasCourse = !!state.course;
        const activeHead = state.playheads[state.tracks.activeTrack];
        const currentDistance = hasCourse ? activeHead.courseDistance : activeHead.cumulative;
        const maxDistance = computeMaxDistance(state.scene.course, state.scene.activities, state.tracks);
        return { currentDistance, maxDistance, units: state.stats.units };
    }
    else {
        return { currentDistance: undefined, maxDistance: undefined, units: state.stats.units };
    }
}
function DistanceText({ maxDistance, currentDistance, units }) {
    const imperial = units === 'imperial';
    const label = imperial ? ' mi' : ' km';
    const distU = imperial ? currentDistance * 0.000621371 : currentDistance * 0.001;
    const distStr = distU.toFixed(distU < 10 ? 2 : 1);
    const totalU = imperial ? maxDistance * 0.000621371 : maxDistance * 0.001;
    const totalStr = totalU.toFixed(totalU < 10 ? 2 : 1) + label;
    return maxDistance > 0.0 ? (React.createElement("span", { className: style.distanceText },
        distStr,
        " / ",
        totalStr)) : null;
}
export default connect(mapStateToProps)(DistanceText);
